import { Button, Dialog, DialogActions, DialogTitle, List, ListItem } from "@mui/material";
import { LensRule } from "generated/graphql";
import { useAppSelector } from "redux/hooks";
import { selectLensEditorLensId, selectRules } from "redux/slices/lensEditor";
import { RuleEditor } from "routes/lens-editor/RuleEditor";

interface DuplicatesDialogProps {
  rule: LensRule;
  close: () => void;
  open: boolean;
}

const DuplicatesDialog = (props: DuplicatesDialogProps) => {
  const { rule, close, open } = props;
  const rules = useAppSelector(selectRules);
  const lensId = useAppSelector(selectLensEditorLensId);
  const duplicates = rules.filter((r) => {
    if (rule.entityQuery?.entityId) {
      return r.entityQuery?.entityId === rule.entityQuery.entityId && r.ruleId !== rule.ruleId;
    } else {
      return r.textQuery?.text === rule.textQuery?.text && r.ruleId !== rule.ruleId;
    }
  });
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>Duplicates for {rule.ruleId}</DialogTitle>
      <List>
        {duplicates.map((d) => (
          <ListItem key={d.ruleId} divider>
            <RuleEditor rule={d} lensId={lensId} key={JSON.stringify(d)} />
          </ListItem>
        ))}
      </List>
      <DialogActions>
        <Button color="default" variant="outlined" onClick={close}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicatesDialog;
